import React, { Component } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { RouteComponentProps, withRouter } from "react-router-dom";
import LightModePageTemplate from "../page/Templates/LightModeTemplate";
import SideBarTemplate from "../side-bar/SideBarTemplate";
import LookupService from "../../services/LookupService";
import outstandingActionsUtilities, { itemTypes } from "../Outstanding-Actions/OutstandingActionsUtilities";
import BulletinPanel from "../BulletinPanel/BulletinPanel";
import SimpleGridService from "../../services/SimpleGridService";
import { LoadIndicator } from "devextreme-react";
import VenueCalendarPageSidebarPanel from "./VenueCalendarPageSidebarPanel";
import ViewCalendarGrid from "./ViewCalendarGrid";

interface VenueCalendarPageProps extends RouteComponentProps, WithTranslation {
    title: string;
    category: string;
    location: any;
    getBuild: (flag: boolean) => void;
}

interface VenueCalendarPageState {
    clientId: string;
    venueId: string;
    serviceTypeId: string;
    dateFrom: Date;
    clientStartDate: string;
    clientStartDayOfWeekId: number;
    loadPanelVisible: boolean;
    applyButtonClicked: boolean;
    arrowButtonClicked: boolean;
}

class VenueCalendarPage extends Component<VenueCalendarPageProps> {
    conversionUtils: outstandingActionsUtilities;
    state: VenueCalendarPageState;
    SimpleGridService: SimpleGridService;
    lookupService: LookupService;

    constructor(props: VenueCalendarPageProps) {
        super(props);
        this.lookupService = new LookupService();
        this.SimpleGridService = new SimpleGridService();
        this.conversionUtils = new outstandingActionsUtilities();
        this.state = {
            clientId: "",
            venueId: "",
            serviceTypeId: "",
            dateFrom: new Date(),
            clientStartDate: this.getPreviousDateByDayId(
                        new Date(),
                        1
                    ),
            clientStartDayOfWeekId: 1,
            loadPanelVisible: false,
            applyButtonClicked: false,
            arrowButtonClicked: false,
        };
    }
    componentDidUpdate(
        prevProps: Readonly<VenueCalendarPageProps>,
        prevState: Readonly<VenueCalendarPageState>,
        snapshot?: any
    ): void {
        if (
            prevState.dateFrom != this.state.dateFrom ||
            prevState.clientStartDayOfWeekId != this.state.clientStartDayOfWeekId
        ) {
            this.setState(
                {
                    clientStartDate: this.getPreviousDateByDayId(
                        this.state.dateFrom,
                        this.state.clientStartDayOfWeekId
                    ),
                },
                () => {
                    if (this.state.arrowButtonClicked) {
                        this.setState({ applyButtonClicked: true });
                    }
                }
            );
        }
    }
    onApplyButtonClick = () => {
        this.setState({
            applyButtonClicked: true,
        });
    };

    getPreviousDateByDayId = (startDateInput: Date | Date, dayId: number): string => {
        if (!startDateInput || dayId < 1 || dayId > 7) return "";

        const date = startDateInput;
        const targetDay = dayId - 1; // convert to JS day (0–6)

        while (date.getDay() !== targetDay) {
            date.setDate(date.getDate() - 1); // go backward one day
        }

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        return `${day}/${month}/${year}`;
    };

    setVenueId = (id: string) => {
        this.setState({ venueId: id });
    };
    setClientId = (id: string) => {
        this.setState({ clientId: id });
    };
    setServiceTypeId = (id: string) => {
        this.setState({ serviceTypeId: id });
    };
    setDateFrom = (date: Date) => {
        this.setState({ dateFrom: date });
    };
    setClientStartDayOfWeekId = (id: number) => {
        this.setState({ clientStartDayOfWeekId: id });
    };
    setApplyButtonClicked = (value: boolean) => {
        this.setState({ applyButtonClicked: value });
    };
    setArrowButtonClicked = (value: boolean) => {
        this.setState({ arrowButtonClicked: value });
    };
    render() {
        return (
            <LightModePageTemplate>
                <SideBarTemplate isFixed={true}>
                    <VenueCalendarPageSidebarPanel
                        setServiceTypeId={this.setServiceTypeId}
                        setClientId={this.setClientId}
                        setVenueId={this.setVenueId}
                        venueId={this.state.venueId}
                        serviceTypeId={this.state.serviceTypeId}
                        clientId={this.state.clientId}
                        dateFrom={this.state.dateFrom}
                        setDateFrom={this.setDateFrom}
                        setClientStartDayOfWeekId={this.setClientStartDayOfWeekId}
                        onApplyButtonClick={this.onApplyButtonClick}
                    />
                    <BulletinPanel />
                </SideBarTemplate>

                <div className="page-content--with-sidebar-hidden-mobile">
                    <header className="grid-info mt-3 mb-3">
                        <h2 className="page-title__black">Venue Calendar</h2>
                    </header>
                    {this.state.applyButtonClicked && (
                        <div className="starter-template">
                            <LoadIndicator
                                id="simple-grid-indicator"
                                height={100}
                                width={100}
                                visible={this.state.applyButtonClicked}
                            />
                        </div>
                    )}
                    <ViewCalendarGrid
                        initialStart={this.state.clientStartDate}
                        venueId={this.state.venueId}
                        serviceTypeId={this.state.serviceTypeId}
                        clientId={this.state.clientId}
                        applyButtonClicked={this.state.applyButtonClicked}
                        setApplyButtonClicked={this.setApplyButtonClicked}
                        setDateFrom={this.setDateFrom}
                        setArrowButtonClicked={this.setArrowButtonClicked}
                    />
                </div>
            </LightModePageTemplate>
        );
    }
}

export default withRouter(withTranslation()(VenueCalendarPage) as React.ComponentType<any>);
